import React from 'react';

import dynamic from 'next/dynamic';

// import ReactJson from 'react-json-view';
const ReactJson = dynamic(() => import('react-json-view'), { ssr: false });

export default function JSONViewer({ file }: any) {
  const sol = JSON.parse(JSON.stringify(file));

  return (
    <div className="p-4 h-full overflow-auto">
      {file && (
        <ReactJson
          src={sol}
          theme={'shapeshifter:inverted'}
          iconStyle="square"
          enableClipboard={false}
          displayObjectSize={false}
          displayDataTypes={false}
        />
      )}
    </div>
  );
}
